import React from 'react'
import type { UseFormRegister, FieldValues, FieldErrors } from 'react-hook-form'
import { Input, Select } from '@climate/components'
import { countries } from '../../consts'
import type { Address } from '../../types'

interface AddressSectionProps {
  title: string
  prefix: string
  isDraft: boolean
  address: Address
  countryValue: string
  register: UseFormRegister<FieldValues>
  errors: FieldErrors
}

export default function AddressSection({
  title,
  prefix,
  isDraft,
  address,
  countryValue,
  register,
  errors,
}: AddressSectionProps) {
  return (
    <>
      <h3 className="text-lg leading-6 font-medium text-gray-900 pb-4 border-b border-gray-300">
        {title}
      </h3>
      <div className="grid sm:gap-x-8 gap-y-4 grid-cols-1 sm:grid-cols-12 pt-4">
        <div className="sm:col-span-6">
          <label htmlFor={`${prefix}_line1`} className="pb-2 block text-sm text-gray-700">
            Address
          </label>
          {isDraft
            ? <Input
              id={`${prefix}_line1`}
              name={`${prefix}_line1`}
              register={register(`${prefix}_line1`, { required: 'Required' })}
              errors={errors}
              autoComplete="address-line1"
            />
            : <span>{address?.line1}</span>
          }
        </div>

        <div className="sm:col-span-6">
          <label htmlFor={`${prefix}_city`} className="pb-2 block text-sm text-gray-700">
            City
          </label>
          {isDraft
            ? <Input
              id={`${prefix}_city`}
              name={`${prefix}_city`}
              register={register(`${prefix}_city`, { required: 'Required' })}
              errors={errors}
            />
            : <span>{address?.city}</span>
          }
        </div>

        <div className="sm:col-span-4">
          <label htmlFor={`${prefix}_country`} className="pb-2 block text-sm text-gray-700">
            Country
          </label>
          {isDraft
            ? <Select
              id={`${prefix}_country`}
              name={`${prefix}_country`}
              options={Object.keys(countries)}
              register={register(`${prefix}_country`, { required: 'Required' })}
              errors={errors}
              placeholder=""
              className="mr-4"
            />
            : <span>{address?.country}</span>
          }
        </div>

        <div className="sm:col-span-4">
          <label htmlFor={`${prefix}_region`} className="pb-2 block text-sm text-gray-700">
            State / Province
          </label>
          {isDraft
            ? <Select
              id={`${prefix}_region`}
              name={`${prefix}_region`}
              disabled={!countryValue}
              options={countries[countryValue] || []}
              register={register(`${prefix}_region`, { required: 'Required' })}
              errors={errors}
              placeholder=""
              className="mr-4"
            />
            : <span>{address?.region}</span>
          }
        </div>

        <div className="sm:col-span-4">
          <label htmlFor={`${prefix}_postal_code`} className="pb-2 block text-sm text-gray-700">
            Postal code
          </label>
          {isDraft
            ? <Input
              id={`${prefix}_postal_code`}
              name={`${prefix}_postal_code`}
              register={register(`${prefix}_postal_code`, { required: 'Required' })}
              errors={errors}
              autoComplete="postal-code"
            />
            : <span>{address?.postal_code}</span>
          }
        </div>
      </div>
    </>
  )
}
